import { axiosClient } from '@nx-frontend/shared/api';
import { assertServiceHost } from '@nx-frontend/shared/api/services/util';
import { PortalServicePageDto } from '@nx-frontend/shared/types';

export type GetPortalPagesProps = {
  host: string;
  superSecret: string;
  workspaceId: string;
  noteIds?: string[];
  pageIds?: string[];
};
export async function getPortalPages({
  host,
  superSecret,
  ...restProps
}: GetPortalPagesProps): Promise<PortalServicePageDto[]> {
  const response = await axiosClient.get<PortalServicePageDto[]>(`${assertServiceHost(host)}/v1/pages`, {
    params: {
      ...restProps,
    },
    secret: superSecret,
  });

  return response.data;
}
